import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "../Reveal";

const stats = [
  { big: "26%", small: "of the global AI workforce is female", note: "The technology reshaping your life is being built mostly without women in the room.", wide: true },
  { big: "8 in 10", small: "women work in roles exposed to AI automation", note: "Admin, scheduling, customer service — the jobs women hold are changing first. Exposure is not destiny: women who learn the tools become irreplaceable.", wide: false },
  { big: "3 sec", small: "of audio to clone a loved one's voice", note: "AI scams target trusting people — especially grandmothers. One family code word defeats them.", wide: false },
  { big: "$0", small: "what it costs to start learning", note: "Every AIWC guide is free. Education is the great equalizer — and it belongs to you too.", wide: true },
];

export const Problem = () => (
  <section id="problem" className="py-20 md:py-28 lg:py-36" data-testid="problem-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 md:mb-20">
        <div className="lg:col-span-5">
          <Reveal><Eyebrow>01 · Why it matters</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif font-semibold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-[1.12]" data-testid="problem-heading">
              The biggest shift of our lifetime is happening <em className="text-ember">without us.</em>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:col-start-8 flex items-end">
          <Reveal delay={0.2}>
            <p className="text-base sm:text-lg text-stone-600 leading-relaxed">
              AI already influences job applications, bank decisions, hospital queues and the prices
              you see online. Women who stayed home to raise families were never invited into this
              conversation. We are changing that — one plain-English lesson at a time.
            </p>
          </Reveal>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8 items-stretch">
        {stats.map((s, i) => (
          <Reveal key={i} delay={i * 0.08}
                  className={s.wide ? "md:col-span-7" : "md:col-span-5"}>
            <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.3, ease: "easeOut" }}
                 className="h-full bg-white rounded-2xl border border-linen p-8 sm:p-10 transition-shadow duration-300 hover:shadow-xl hover:shadow-stone-900/10"
                 data-testid={`problem-stat-card-${i}`}>
              <p className="font-serif font-bold text-ember text-6xl sm:text-7xl tracking-tight">{s.big}</p>
              <p className="mt-4 font-serif text-xl sm:text-2xl text-ink leading-snug">{s.small}</p>
              <p className="mt-4 text-sm text-stone-600 leading-relaxed">{s.note}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
